(() => {
  if (window.CTHeroV17) return;
  window.CTHeroV17 = true;

  const SELECTORS = {
    section: '[data-ct-hero]',
    track: '[data-ct-hero-track]',
    slide: '[data-ct-hero-slide]',
    dot: '[data-ct-hero-dot]',
    prev: '[data-ct-hero-prev]',
    next: '[data-ct-hero-next]',
    viewport: '.ct-hero__viewport'
  };

  function initHero(section) {
    if (!section || section.dataset.ctHeroReady === 'true') return;
    section.dataset.ctHeroReady = 'true';
    section.classList.add('is-ready');

    const track = section.querySelector(SELECTORS.track);
    const slides = Array.from(section.querySelectorAll(SELECTORS.slide));
    const dots = Array.from(section.querySelectorAll(SELECTORS.dot));
    const prev = section.querySelector(SELECTORS.prev);
    const next = section.querySelector(SELECTORS.next);
    const viewport = section.querySelector(SELECTORS.viewport) || track;

    if (!track || !viewport || slides.length <= 1) return;

    let currentIndex = 0;
    let autoplayTimer = null;
    let isDragging = false;
    let isHorizontalSwipe = false;
    let hasDragged = false;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let dragDelta = 0;

    const autoplay = section.dataset.autoplay === 'true';
    const rawAutoplaySpeed = Number.parseFloat(section.dataset.autoplaySpeed || '3500');
    const autoplaySpeed = Number.isFinite(rawAutoplaySpeed) ? Math.max(1500, rawAutoplaySpeed) : 3500;
    const swipeThresholdRatio = 0.16;
    const swipeMinThreshold = 42;

    viewport.style.touchAction = 'pan-y';

    function getSlideWidth() {
      return viewport.clientWidth || track.clientWidth || 1;
    }

    function setTransition(enabled) {
      track.style.transition = enabled ? '' : 'none';
    }

    function setTransform(index, deltaPx = 0) {
      const width = getSlideWidth();
      const basePercent = -index * 100;
      const deltaPercent = (deltaPx / width) * 100;
      track.style.transform = `translateX(calc(${basePercent}% + ${deltaPercent}%))`;
    }

    function setActive(index, options = {}) {
      const { immediate = false } = options;
      currentIndex = (index + slides.length) % slides.length;
      if (immediate) setTransition(false);
      else setTransition(true);
      setTransform(currentIndex, 0);
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      if (immediate) requestAnimationFrame(() => setTransition(true));
    }

    function stopAutoplay() {
      if (autoplayTimer) window.clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      if (!autoplay || slides.length <= 1 || isDragging || document.hidden) return;
      stopAutoplay();
      autoplayTimer = window.setTimeout(() => {
        setActive(currentIndex + 1);
        startAutoplay();
      }, autoplaySpeed);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function beginDrag(event) {
      if (event.button !== undefined && event.button !== 0) return;
      pointerId = event.pointerId;
      isDragging = true;
      isHorizontalSwipe = false;
      hasDragged = false;
      dragDelta = 0;
      startX = event.clientX;
      startY = event.clientY;
      currentX = startX;
      stopAutoplay();
      setTransition(false);
      viewport.classList.add('is-swiping');
      if (viewport.setPointerCapture) viewport.setPointerCapture(pointerId);
    }

    function moveDrag(event) {
      if (!isDragging || event.pointerId !== pointerId) return;
      currentX = event.clientX;
      const deltaX = currentX - startX;
      const deltaY = event.clientY - startY;
      if (!isHorizontalSwipe && Math.abs(deltaX) > 8) isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
      if (!isHorizontalSwipe) return;
      hasDragged = Math.abs(deltaX) > 6;
      dragDelta = deltaX;
      event.preventDefault();
      setTransform(currentIndex, dragDelta);
    }

    function endDrag(event) {
      if (!isDragging || (event && event.pointerId !== pointerId)) return;
      const width = getSlideWidth();
      const threshold = Math.max(swipeMinThreshold, width * swipeThresholdRatio);
      const shouldMove = Math.abs(dragDelta) > threshold;
      isDragging = false;
      viewport.classList.remove('is-swiping');
      setTransition(true);
      if (shouldMove) setActive(dragDelta < 0 ? currentIndex + 1 : currentIndex - 1);
      else setActive(currentIndex);
      if (event && viewport.hasPointerCapture && viewport.hasPointerCapture(pointerId)) viewport.releasePointerCapture(pointerId);
      pointerId = null;
      dragDelta = 0;
      startAutoplay();
    }

    dots.forEach((dot) => dot.addEventListener('click', () => {
      setActive(Number(dot.dataset.ctHeroDot || 0));
      restartAutoplay();
    }));

    if (prev) prev.addEventListener('click', () => {
      setActive(currentIndex - 1);
      restartAutoplay();
    });

    if (next) next.addEventListener('click', () => {
      setActive(currentIndex + 1);
      restartAutoplay();
    });

    viewport.addEventListener('pointerdown', beginDrag);
    viewport.addEventListener('pointermove', moveDrag);
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', endDrag);

    viewport.addEventListener('click', (event) => {
      if (!hasDragged) return;
      event.preventDefault();
      event.stopPropagation();
      hasDragged = false;
    }, true);

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });
    window.addEventListener('resize', () => setActive(currentIndex, { immediate: true }));

    setActive(0, { immediate: true });
    startAutoplay();
  }

  function initAllHeroes() {
    document.querySelectorAll(SELECTORS.section).forEach(initHero);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllHeroes, { once: true });
  else initAllHeroes();
  document.addEventListener('shopify:section:load', initAllHeroes);
  window.CTHero = { version: '1.7', init: initAllHeroes };
})();
